import Share from "@/common/social/share"
import Image from "next/legacy/image"
import { usePathData, usePropsObject } from "@/lib/contexts/appContext"
import useStrings from "@/lib/hooks/useStrings"
import styles from "./article-meta.module.css"

export default function PostMeta() {
  const pathData = usePathData()
  const object = usePropsObject()
  let info = [],
    avatar

  const hasContent = pathData.content.length > 3
  const { byline, photo, published, updated, readTime } = useStrings()
  // allow for article-hero, article-sidebars and a single block

  if (object.byline) {
    avatar =
      object.byline.avatar.length !== 0 ? (
        <div className="mr-3 w-icon-lg h-icon-lg">
          {object.byline.avatar.url && (
            <figure className={`aspect-w-16 aspect-h-16 ${styles.avatar}`}>
              <Image
                className={`object-cover object-center w-full h-full`}
                src={object.byline.avatar.url}
                sizes="256px"
                alt={object.byline.avatar.alt}
                layout="fill"
                loading="lazy"
              />
            </figure>
          )}
        </div>
      ) : null
    info.push(byline + " " + object.byline.name)
  }

  if (object.mediaAuthor) {
    info.push(photo + object.mediaAuthor)
  }

  let dateLine = [published + " " + object.created]

  if (object.created !== object.modified) {
    dateLine.push(updated + " " + object.modified)
  }

  if (hasContent && object.readTime > 0) {
    dateLine.push(object.readTime + " " + (readTime ?? "min att läsa"))
  }

  info.push(dateLine.join(" • "))

  const rows = info.map((item, index) => {
    return (
      <span className="block" key={index}>
        {item}
      </span>
    )
  })
  return (
    <div className="post-meta-wrapper">
      <div className="md:flex md:justify-between md:items-center">
        <div className="flex flex-1 pr-4 mb-5 font-sans text-sm leading-normal meta-data text-black-100/80 md:mb-0">
          {avatar}
          <div className="flex flex-col justify-center">{rows}</div>
        </div>
        {hasContent && (
          <Share
            classes="mr-2 w-icon h-icon"
            url={object.url}
            sharing={object.sharing}
          />
        )}
      </div>
    </div>
  )
}
